<template>
  <div class="form-container" style="height: 250px;position: relative;padding-left: 0;">
    <el-form ref="form" label-position="top" :rules="rules" :model="formLabelAlign" class="product-form">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$t('product_name')" prop="name">
            <el-input class="gray-theme" v-model="formLabelAlign.name" :disabled='readonly'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('price')" prop='userMonthPrice'>
            <el-input class="gray-theme price-suffix" v-model="formLabelAlign.userMonthPrice" :disabled='readonly'>
              <span slot="suffix" class="suffix-title">{{ $t('user_month') }}</span>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('currency')" prop='currency'>
            <el-select v-model="formLabelAlign.currency" :disabled="readonly" class="gray-theme" style="width: 100%" filterable placeholder="">
              <el-option v-for="item in currencyListData" :key="item.code" :label="item.code" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('modules')">
            <el-select v-model="formLabelAlign.appModuleList" :disabled="readonly" class="gray-theme" multiple style="width: 100%" filterable placeholder="">
              <el-option v-for="item in moduleListData" :key="item.appModuleList" :label="item.appModuleList" :value="item.appModuleList">
              </el-option>
            </el-select>
            <el-input :disabled="readonly" class="gray-theme" v-model="formLabelAlign.appModuleList"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item class="upload-img" :label="$t('image')" style="float: none">
            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :class="{'upload-disabled': readonly}" :disabled="readonly" :auto-upload="false" :on-change="upload">
              <img v-if="imgFile.dataUrl" :src="imgFile.dataUrl" class="avatar">
              <i class="common-icon icon-upload avatar-uploader-icon" style="line-height: 80px;"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item :label="$t('description')" style="margin-left: 10px;">
            <el-input :disabled="readonly" class="gray-theme" type="textarea" :rows="2" maxlength="500" v-model="formLabelAlign.description" :readonly='readonly'></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import fileApi from '@/apis/file-api';
import productApi from '@/apis/product';
import commonApi from '@/apis/common';
import { EventBus } from '../../../../common/eventBus/eventbus';
export default {
  data() {
    var checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('required')));
        return;
      }
      if (!this.$formValidation.twoPointreg.test(value)) {
        callback(new Error(this.$t('required')));
        return;
      }
      if (value < 0 || value > 9999999999999.99) {
        callback(new Error(this.$t('moneyNumber_format_error')));
        return;
      }
      callback();
    };
    return {
      formLabelAlign: {
        name: '',
        userMonthPrice: '',
        description: '',
        photo: '',
        appVersion: '',
        appModuleList: '',
        currency: '',
        basePrice: ''
      },
      imgFile: {
        dataUrl: '',
        name: ''
      },
      dialogVisible: false,
      Product: '',
      moduleListData: [],
      currencyListData: [],
      imageUrl: '',
      rules: {
        name: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          },
          {
            min: 1,
            max: 100,
            message: 'length:1-100'
          }
        ],
        userMonthPrice: [
          { validator: checkMoney, trigger: 'blur' },
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        currency: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ]
      }
    };
  },

  model: {
    prop: 'modelData',
    event: 'change'
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    modelData: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.init();
    this.formLabelAlign = this.formData;
  },

  beforeDestroy() {},

  watch: {},

  methods: {
    init() {
      this.getCurrency();
    },

    async getCurrency() {
      const req = {};
      const res = await commonApi.getCurrency(req);
      console.log(res);
      this.currencyListData = res.list;
      const imgReq = {
        id: this.formLabelAlign.photo
      };
      if (imgReq.id) {
        const imgRes = await fileApi.getImageDataUrl(imgReq);
        this.imgFile.dataUrl = imgRes;
      }
    },

    async Submit() {
      if (this.title === 'update') {
        const req = {
          ...this.formLabelAlign
        };
        const res = await productApi.modifyProduct(req);
        if (res.reason) {
          this.$message({
            // message: '状态不符',
            message: this.$t('status_discrepancy'),
            type: 'error',
            duration: 5000,
            offset: 80
          });
        } else {
          EventBus.$emit('handleOkClick');
          this.$emit('dialogVisible', false);
          this.$message({
            // message: '修改成功',
            message: this.$t('modify_success'),
            type: 'success',
            duration: 5000,
            offset: 80
          });
        }
      } else {
        const req = {
          ...this.formLabelAlign
        };
        req.photo = '';
        if (this.imgFile.name) {
          const data = await fileApi.imgSave({
            ...this.imgFile
          });
          req.photo = data.id;
        }
        console.log(req);
        const res = await productApi.addNewProduct(req);
        console.log(res);
        if (res.reason) {
        } else {
          EventBus.$emit('handleOkClick');
          this.$emit('dialogVisible', false);
          this.$message({
            // message: '创建成功',
            message: this.$t('created_success'),
            type: 'success',
            duration: 5000,
            offset: 80
          });
        }
      }
    },

    async upload(data, file) {
      const reader = new FileReader();
      this.imageUrl = reader.readAsDataURL(data.raw);
      reader.onload = (ev) => {
        this.imgFile.dataUrl = ev.target.result;
        this.imgFile.name = data.raw.name;
      };
    }

    // async addAction() {
    //   req.photo = '';
    //   if (this.imgFile.name) {
    //     const data = await fileApi.imgSave({
    //       ...this.imgFile
    //     });
    //     req.photo = data.id;
    //     console.log(req.photo);
    //   }
    // }
  }
};
</script>

<style lang="scss">
.none {
  display: none;
}

.product-form {
  .el-form-item__label {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0;
  }
  .el-form-item__content {
    text-align: left;
    .el-textarea__inner {
      height: 80px;
    }
  }
}

.el-divider {
  background: #c7c8c9;
}

.el-upload {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
}

.upload-img {
  text-align: left;
  .el-form-item__label {
    float: none;
  }
}

.price-suffix {
  .el-input__inner {
    padding-right: 90px;
  }
}

.suffix-title {
  font-size: 16px;
  color: #292929;
}

.upload-disabled {
  .el-upload {
    cursor: not-allowed;
    background: #dbdbdb;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #3266FF;
}
.avatar-uploader-icon {
  font-size: 16px;
  color: #292929;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
  display: inline-block;
}
.avatar {
  width: 78px;
  height: 78px;
  display: block;
}
</style>
